<div class="fullscreen">
  <div class="fullscreen__container">
    <div class="fullscreen__card">
      <div class="fullscreen__header">
        You broke it!
      </div>
      <div class="fullscreen__content">
        Just kidding, this page doesn't exist or you followed a bad link.
      </div>
      <div class="fullscreen__footer">
        <button class="button button--primary" (click)="goHome()" type="button">
          <i class="material-icons">&#xE88A;</i>
          <span>Go home</span>
        </button>
        <div class="fullscreen__status-code">
          404 Not Found
        </div>
      </div>
    </div>
    <div class="fullscreen__logo-stack">
      <div class="fullscreen__logo-container">
        <img class="fullscreen__logo" src="../assets/full-logo-dark.svg" [ngStyle]="getLogoStyle" alt="Tartan + Hummingbird Logo" />
      </div>
      <span class="fullscreen__release-number">v{{releaseNumber}}</span>
    </div>
  </div>
</div>
